/**
 * Phase 4 Task 7 — voicemail event contracts.
 *
 * `voicemail.new` is published by the worker voicemail handler after a
 * RecordingFinished ARI event for a voicemail-namespaced recording is
 * encrypted and persisted. The intended consumer is the agent inbox
 * notifier (ws-gateway in a future task) which pushes the event over the
 * agent's websocket so the unread voicemail badge updates in real time.
 *
 * `agentId` is nullable: an IVR-routed voicemail (e.g. an after-hours
 * fall-through) may not have a specific target agent. The inbox view
 * shows those under the queue/department mailbox.
 */
import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
export const VoicemailNewEventSchema = z.object({
    type: z.literal('voicemail.new'),
    ...baseEventFields,
    voicemailId: uuidSchema,
    callId: uuidSchema,
    agentId: uuidSchema.nullable(),
    durationMs: z.number().int().nonnegative(),
});
//# sourceMappingURL=voicemail.js.map